// Default avatar generator. Produces an inline SVG data URL with the user's
// initials on a deterministic background color, used as the fallback when
// profileData.avatar is missing or fails to load.
//
// Replaces an Unsplash stock photo of a specific woman that was shipping as
// every un-avatared profile's display image. See QA report 2026-04-24.

const PALETTE = [
  '#EF4444', // red-500
  '#F97316', // orange-500
  '#F59E0B', // amber-500
  '#10B981', // emerald-500
  '#14B8A6', // teal-500
  '#3B82F6', // blue-500
  '#8B5CF6', // violet-500
  '#EC4899', // pink-500
];

export function getInitials(name) {
  if (!name || typeof name !== 'string') return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) {
    const letter = parts[0][0];
    return letter ? letter.toUpperCase() : '?';
  }
  const first = parts[0][0] || '';
  const last = parts[parts.length - 1][0] || '';
  return (first + last).toUpperCase() || '?';
}

export function getAvatarColor(name) {
  if (!name) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash) + name.charCodeAt(i);
    hash |= 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

// Returns an inline SVG data URL safe for use as <img src>. Renders a filled
// circle with the user's initials in white. Works in browsers, Open Graph
// crawlers, email clients that support data URLs.
export function defaultAvatarDataUrl(name, size = 256) {
  const initials = getInitials(name);
  const bg = getAvatarColor(name);
  const fontSize = Math.round(size * 0.42);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" width="${size}" height="${size}"><circle cx="${size / 2}" cy="${size / 2}" r="${size / 2}" fill="${bg}"/><text x="50%" y="50%" dy="0.36em" text-anchor="middle" font-family="-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif" font-size="${fontSize}" font-weight="700" fill="#ffffff">${initials}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
